export default "<div class=dashboard-r-g-w> <div ng-if=\"vm.showIfEmpty || (vm.rejectsPretty && vm.rejectsPretty.length)\"> <div> <high-chart options=vm.rejectsPretty id=rejectsChart style=display:block;width:100% /> </div> <div class=text-center> <btn-array options=vm.shiftSelectors id=rejectsButtons /> </div> </div> <div ng-if=\"!vm.showIfEmpty && vm.rejectsPretty && !vm.rejectsPretty.length\"> <div> No rejects for this Shop </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/dashboard/topRejectsGraph.tpl.html
// module id = 533
// module chunks = 0